<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center ">
                        <div class="flex align-center margin-right-sm " v-if="[3].includes(user.power)">
                            <span>社区：</span>
                            <el-select v-model="xiangmu_id" placeholder="请选择社区" filterable clearable>
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex align-center margin-right-sm ">
                            <span>关键字：</span>
                            <el-input v-model="name" placeholder="请输入关键字" class="flex-sub"></el-input>
                        </div>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
<!--                        <router-link to="/home/gzh/active/record" class="margin-lr-xs">-->
<!--                            <el-button type="primary">兑换记录</el-button>-->
<!--                        </router-link>-->
                    </div>
                </div>
                <div>
                    <el-button type="primary" @click="editItem(0)">添加活动</el-button>
                </div>

            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table
                :data="lists"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%"
            >
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="所属社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="活动名称" prop="name"></el-table-column>
                <el-table-column label="活动时间" prop="time"></el-table-column>
                <el-table-column label="活动人数" prop="number"></el-table-column>
                <el-table-column label="活动积分" prop="points"></el-table-column>
                <el-table-column label="活动类型" prop="type_name"></el-table-column>
                <el-table-column label="创建时间" prop="create_time"></el-table-column>
<!--                <el-table-column label="兑换/预定的开始时间" prop="exchange_start_time"></el-table-column>-->
<!--                <el-table-column label="兑换/预定的结束时间" prop="exchange_end_time"></el-table-column>-->
                <el-table-column label="操作" width="330">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="primary"
                                @click="editItem(scope.row.id)"
                            >编辑
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="recordItem(scope.row.id)"
                            >报名记录
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="delItem(scope.row.id)"
                            >删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="lists.length > 0"
                class="page-all"
                background
                @current-change="getList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getXiangMuList} from "@/api/common";
import {delActive, getActiveList} from "@/api/gzh";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            projectList:[],
            name: '',
            xiangmu_id: '',
            page: 1,
            limit: 10,
            total: 0,
            lists: [],
            shoppingOneKeyDialog:false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 公众号管理 / 活动管理", false);
        this.getList()
        this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{name:'全部',id:0},...project.data]
        },
        //  活动删除
        delItem(id) {
            this.$confirm('您确定要删除该活动吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delActive(id);
            this.getList();
            this.$message.success(_state.info);
        },
        //  活动编辑
        editItem(id) {
            this.$router.push('/home/gzh/active/add/' + id)
        },
        recordItem(id) {
            this.$router.push('/home/gzh/active/record/' + id)
        },
        //  搜索
        handleSearch() {
            this.page = 1
            this.getList()
        },
        //  获取活动列表
        async getList() {
            let _data = await getActiveList(
                this.name,
                this.xiangmu_id,
                this.page,
                this.limit,
            )
            this.lists = _data.data
            this.total = _data.total_number
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
